/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  MaterialMean,
  MaterialMeanResponse,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchMaterialMeansRequest,
  SearchMaterialMeansResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    MaterialMeanFromJSON,
    MaterialMeanToJSON,
    MaterialMeanResponseFromJSON,
    MaterialMeanResponseToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchMaterialMeansRequestFromJSON,
    SearchMaterialMeansRequestToJSON,
    SearchMaterialMeansResponseFromJSON,
    SearchMaterialMeansResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnMaterialMeanByIdRequest {
    materialMeanId: string;
    contentType: CreateChangeRequestOnMaterialMeanByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateMaterialMeanRequest {
    contentType: CreateMaterialMeanContentTypeEnum;
    xBOLMemberIdentifier: string;
    materialMean: MaterialMean;
    id?: string;
    source?: boolean;
    accept?: CreateMaterialMeanAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateMaterialMeanEventRequest {
    materialMeanId: string;
    contentType: CreateMaterialMeanEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateMaterialMeanEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteMaterialMeanACLAuthorizationByMemberIdRequest {
    materialMeanId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteMaterialMeanByIdRequest {
    materialMeanId: string;
    traceparent?: string;
}

export interface DeleteMaterialMeanEventByIdRequest {
    materialMeanId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnMaterialMeanByIdRequest {
    materialMeanId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface GetMaterialMeanACLAuthorizationByMemberIdRequest {
    materialMeanId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetMaterialMeanACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetMaterialMeanACLByIdRequest {
    materialMeanId: string;
    at?: string;
    revision?: string;
    accept?: GetMaterialMeanACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetMaterialMeanByIdRequest {
    materialMeanId: string;
    at?: string;
    revision?: string;
    accept?: GetMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface GetMaterialMeanEventsRequest {
    materialMeanId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetMaterialMeanEventsAcceptEnum;
    traceparent?: string;
}

export interface GetMaterialMeanMetadataByIdRequest {
    materialMeanId: string;
    accept?: GetMaterialMeanMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfMaterialMeanByIdRequest {
    materialMeanId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchMaterialMeanByIdRequest {
    materialMeanId: string;
    contentType: PatchMaterialMeanByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    materialMean: MaterialMean;
    revision?: string;
    accept?: PatchMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchMaterialMeanGetRequest {
    id?: string;
    searchBody?: SearchMaterialMeansRequest;
    accept?: SearchMaterialMeanGetAcceptEnum;
    traceparent?: string;
}

export interface SearchMaterialMeansPostRequest {
    contentType: SearchMaterialMeansPostContentTypeEnum;
    searchMaterialMeansRequest: SearchMaterialMeansRequest;
    limit?: number;
    offset?: number;
    accept?: SearchMaterialMeansPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnMaterialMeanByIdRequest {
    materialMeanId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnMaterialMeanByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateMaterialMeanByIdRequest {
    materialMeanId: string;
    contentType: UpdateMaterialMeanByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    materialMean: MaterialMean;
    revision?: string;
    accept?: UpdateMaterialMeanByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertMaterialMeanACLAuthorizationByIdRequest {
    materialMeanId: string;
    contentType: UpsertMaterialMeanACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertMaterialMeanACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsMaterialMeansApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific MaterialMean resource, identified by its `MaterialMeanId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the MaterialMean resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a MaterialMean resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the MaterialMean resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a MaterialMean
     */
    async createChangeRequestOnMaterialMeanByIdRaw(requestParameters: CreateChangeRequestOnMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling createChangeRequestOnMaterialMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnMaterialMeanById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/change-requests`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific MaterialMean resource, identified by its `MaterialMeanId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the MaterialMean resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a MaterialMean resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the MaterialMean resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a MaterialMean
     */
    async createChangeRequestOnMaterialMeanById(requestParameters: CreateChangeRequestOnMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnMaterialMeanByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new MaterialMean.  When creating a MaterialMean, the value of the header `X-BOL-Member-Identifier` defines the MaterialMean\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a MaterialMean, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the MaterialMean and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the MaterialMean, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the MaterialMean.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a MaterialMean
     */
    async createMaterialMeanRaw(requestParameters: CreateMaterialMeanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialMeanResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createMaterialMean().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createMaterialMean().'
            );
        }

        if (requestParameters['materialMean'] == null) {
            throw new runtime.RequiredError(
                'materialMean',
                'Required parameter "materialMean" was null or undefined when calling createMaterialMean().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialMeanToJSON(requestParameters['materialMean']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new MaterialMean.  When creating a MaterialMean, the value of the header `X-BOL-Member-Identifier` defines the MaterialMean\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a MaterialMean, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the MaterialMean and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the MaterialMean, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the MaterialMean.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a MaterialMean
     */
    async createMaterialMean(requestParameters: CreateMaterialMeanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialMeanResponse | null | undefined > {
        const response = await this.createMaterialMeanRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a MaterialMean by `materialMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a MaterialMean resource. 
     * Create an Event of a MaterialMean
     */
    async createMaterialMeanEventRaw(requestParameters: CreateMaterialMeanEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling createMaterialMeanEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createMaterialMeanEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createMaterialMeanEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createMaterialMeanEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/events`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a MaterialMean by `materialMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a MaterialMean resource. 
     * Create an Event of a MaterialMean
     */
    async createMaterialMeanEvent(requestParameters: CreateMaterialMeanEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMaterialMeanEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a MaterialMean resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the MaterialMean resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a MaterialMean resource. 
     * Delete an authorization of an access control list of a MaterialMean by memberId
     */
    async deleteMaterialMeanACLAuthorizationByMemberIdRaw(requestParameters: DeleteMaterialMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling deleteMaterialMeanACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteMaterialMeanACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteMaterialMeanACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a MaterialMean resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the MaterialMean resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a MaterialMean resource. 
     * Delete an authorization of an access control list of a MaterialMean by memberId
     */
    async deleteMaterialMeanACLAuthorizationByMemberId(requestParameters: DeleteMaterialMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMaterialMeanACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific MaterialMean resource, identified by its `MaterialMeanId`.  - When a MaterialMean is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a MaterialMean resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a MaterialMean resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a MaterialMean resource. 
     * Delete a MaterialMean by materialMeanId
     */
    async deleteMaterialMeanByIdRaw(requestParameters: DeleteMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling deleteMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific MaterialMean resource, identified by its `MaterialMeanId`.  - When a MaterialMean is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a MaterialMean resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a MaterialMean resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a MaterialMean resource. 
     * Delete a MaterialMean by materialMeanId
     */
    async deleteMaterialMeanById(requestParameters: DeleteMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMaterialMeanByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a MaterialMean resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a MaterialMean resource. 
     * Delete an event of a MaterialMean by id
     */
    async deleteMaterialMeanEventByIdRaw(requestParameters: DeleteMaterialMeanEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling deleteMaterialMeanEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteMaterialMeanEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteMaterialMeanEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a MaterialMean resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a MaterialMean resource. 
     * Delete an event of a MaterialMean by id
     */
    async deleteMaterialMeanEventById(requestParameters: DeleteMaterialMeanEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMaterialMeanEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given MaterialMean, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the MaterialMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a MaterialMean by changeRequestId
     */
    async getChangeRequestOnMaterialMeanByIdRaw(requestParameters: GetChangeRequestOnMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling getChangeRequestOnMaterialMeanById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given MaterialMean, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the MaterialMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a MaterialMean by changeRequestId
     */
    async getChangeRequestOnMaterialMeanById(requestParameters: GetChangeRequestOnMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnMaterialMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a MaterialMean resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a MaterialMean resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a MaterialMean by memberId
     */
    async getMaterialMeanACLAuthorizationByMemberIdRaw(requestParameters: GetMaterialMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling getMaterialMeanACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getMaterialMeanACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a MaterialMean resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a MaterialMean resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a MaterialMean by memberId
     */
    async getMaterialMeanACLAuthorizationByMemberId(requestParameters: GetMaterialMeanACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getMaterialMeanACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific MaterialMean resource, identified by its `MaterialMeanId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the MaterialMean and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a MaterialMean resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a MaterialMean for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getMaterialMeanACLByIdRaw(requestParameters: GetMaterialMeanACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling getMaterialMeanACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/acl`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific MaterialMean resource, identified by its `MaterialMeanId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the MaterialMean and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a MaterialMean resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a MaterialMean for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getMaterialMeanACLById(requestParameters: GetMaterialMeanACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getMaterialMeanACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific MaterialMean by its `MaterialMeanId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this MaterialMean resource. 
     * Get a MaterialMean by materialMeanId
     */
    async getMaterialMeanByIdRaw(requestParameters: GetMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialMeanResponse>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling getMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific MaterialMean by its `MaterialMeanId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this MaterialMean resource. 
     * Get a MaterialMean by materialMeanId
     */
    async getMaterialMeanById(requestParameters: GetMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialMeanResponse> {
        const response = await this.getMaterialMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a MaterialMean by `materialMeanId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a MaterialMean resource. 
     * List Events of a MaterialMean
     */
    async getMaterialMeanEventsRaw(requestParameters: GetMaterialMeanEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling getMaterialMeanEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/events`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a MaterialMean by `materialMeanId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a MaterialMean resource. 
     * List Events of a MaterialMean
     */
    async getMaterialMeanEvents(requestParameters: GetMaterialMeanEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getMaterialMeanEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific MaterialMean by its `MaterialMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a MaterialMean metadata by materialMeanId
     */
    async getMaterialMeanMetadataByIdRaw(requestParameters: GetMaterialMeanMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling getMaterialMeanMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/metadata`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific MaterialMean by its `MaterialMeanId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a MaterialMean metadata by materialMeanId
     */
    async getMaterialMeanMetadataById(requestParameters: GetMaterialMeanMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getMaterialMeanMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified MaterialMean, identified by its `MaterialMeanId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given MaterialMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a MaterialMean resource. 
     * Get a list of ChangeRequest for MaterialMean
     */
    async listChangeRequestsOfMaterialMeanByIdRaw(requestParameters: ListChangeRequestsOfMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling listChangeRequestsOfMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/change-requests`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified MaterialMean, identified by its `MaterialMeanId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given MaterialMean resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a MaterialMean resource. 
     * Get a list of ChangeRequest for MaterialMean
     */
    async listChangeRequestsOfMaterialMeanById(requestParameters: ListChangeRequestsOfMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfMaterialMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing MaterialMean identified by its `MaterialMeanId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a MaterialMean resource. 
     * Partially update a MaterialMean by applying a JSON Merge Patch change request
     */
    async patchMaterialMeanByIdRaw(requestParameters: PatchMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialMeanResponse>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling patchMaterialMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchMaterialMeanById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchMaterialMeanById().'
            );
        }

        if (requestParameters['materialMean'] == null) {
            throw new runtime.RequiredError(
                'materialMean',
                'Required parameter "materialMean" was null or undefined when calling patchMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialMeanToJSON(requestParameters['materialMean']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing MaterialMean identified by its `MaterialMeanId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a MaterialMean resource. 
     * Partially update a MaterialMean by applying a JSON Merge Patch change request
     */
    async patchMaterialMeanById(requestParameters: PatchMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialMeanResponse> {
        const response = await this.patchMaterialMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of MaterialMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on MaterialMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of MaterialMean resources. 
     * Search for MaterialMeans
     */
    async searchMaterialMeanGetRaw(requestParameters: SearchMaterialMeanGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMaterialMeansResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMaterialMeansResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of MaterialMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on MaterialMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of MaterialMean resources. 
     * Search for MaterialMeans
     */
    async searchMaterialMeanGet(requestParameters: SearchMaterialMeanGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMaterialMeansResponse> {
        const response = await this.searchMaterialMeanGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of MaterialMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on MaterialMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of MaterialMean resources. 
     * Search for MaterialMeans
     */
    async searchMaterialMeansPostRaw(requestParameters: SearchMaterialMeansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMaterialMeansResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchMaterialMeansPost().'
            );
        }

        if (requestParameters['searchMaterialMeansRequest'] == null) {
            throw new runtime.RequiredError(
                'searchMaterialMeansRequest',
                'Required parameter "searchMaterialMeansRequest" was null or undefined when calling searchMaterialMeansPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchMaterialMeansRequestToJSON(requestParameters['searchMaterialMeansRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMaterialMeansResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of MaterialMean resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on MaterialMeans.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of MaterialMean resources. 
     * Search for MaterialMeans
     */
    async searchMaterialMeansPost(requestParameters: SearchMaterialMeansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMaterialMeansResponse> {
        const response = await this.searchMaterialMeansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given MaterialMean, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a MaterialMean resource. 
     * Accept or reject a ChangeRequest on a  MaterialMean using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnMaterialMeanByIdRaw(requestParameters: UpdateChangeRequestOnMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling updateChangeRequestOnMaterialMeanById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnMaterialMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnMaterialMeanById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given MaterialMean, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a MaterialMean resource. 
     * Accept or reject a ChangeRequest on a  MaterialMean using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnMaterialMeanById(requestParameters: UpdateChangeRequestOnMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnMaterialMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing MaterialMean identified by its `MaterialMeanId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a MaterialMean resource. 
     * Update an existing MaterialMean by creating and applying a change request
     */
    async updateMaterialMeanByIdRaw(requestParameters: UpdateMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialMeanResponse>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling updateMaterialMeanById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateMaterialMeanById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateMaterialMeanById().'
            );
        }

        if (requestParameters['materialMean'] == null) {
            throw new runtime.RequiredError(
                'materialMean',
                'Required parameter "materialMean" was null or undefined when calling updateMaterialMeanById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialMeanToJSON(requestParameters['materialMean']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialMeanResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing MaterialMean identified by its `MaterialMeanId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a MaterialMean resource. 
     * Update an existing MaterialMean by creating and applying a change request
     */
    async updateMaterialMeanById(requestParameters: UpdateMaterialMeanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialMeanResponse> {
        const response = await this.updateMaterialMeanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific MaterialMean resource, identified by its `MaterialMeanId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a MaterialMean resource. 
     * Upsert (create or update) an authorization of an access control list of a MaterialMean.
     */
    async upsertMaterialMeanACLAuthorizationByIdRaw(requestParameters: UpsertMaterialMeanACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['materialMeanId'] == null) {
            throw new runtime.RequiredError(
                'materialMeanId',
                'Required parameter "materialMeanId" was null or undefined when calling upsertMaterialMeanACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertMaterialMeanACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertMaterialMeanACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/material-means/{materialMeanId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"materialMeanId"}}`, encodeURIComponent(String(requestParameters['materialMeanId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific MaterialMean resource, identified by its `MaterialMeanId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a MaterialMean resource. 
     * Upsert (create or update) an authorization of an access control list of a MaterialMean.
     */
    async upsertMaterialMeanACLAuthorizationById(requestParameters: UpsertMaterialMeanACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertMaterialMeanACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnMaterialMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnMaterialMeanByIdContentTypeEnum = typeof CreateChangeRequestOnMaterialMeanByIdContentTypeEnum[keyof typeof CreateChangeRequestOnMaterialMeanByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnMaterialMeanByIdAcceptEnum = typeof CreateChangeRequestOnMaterialMeanByIdAcceptEnum[keyof typeof CreateChangeRequestOnMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const CreateMaterialMeanContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateMaterialMeanContentTypeEnum = typeof CreateMaterialMeanContentTypeEnum[keyof typeof CreateMaterialMeanContentTypeEnum];
/**
 * @export
 */
export const CreateMaterialMeanAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateMaterialMeanAcceptEnum = typeof CreateMaterialMeanAcceptEnum[keyof typeof CreateMaterialMeanAcceptEnum];
/**
 * @export
 */
export const CreateMaterialMeanEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateMaterialMeanEventContentTypeEnum = typeof CreateMaterialMeanEventContentTypeEnum[keyof typeof CreateMaterialMeanEventContentTypeEnum];
/**
 * @export
 */
export const CreateMaterialMeanEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateMaterialMeanEventAcceptEnum = typeof CreateMaterialMeanEventAcceptEnum[keyof typeof CreateMaterialMeanEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnMaterialMeanByIdAcceptEnum = typeof GetChangeRequestOnMaterialMeanByIdAcceptEnum[keyof typeof GetChangeRequestOnMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const GetMaterialMeanACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetMaterialMeanACLAuthorizationByMemberIdAcceptEnum = typeof GetMaterialMeanACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetMaterialMeanACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetMaterialMeanACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetMaterialMeanACLByIdAcceptEnum = typeof GetMaterialMeanACLByIdAcceptEnum[keyof typeof GetMaterialMeanACLByIdAcceptEnum];
/**
 * @export
 */
export const GetMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetMaterialMeanByIdAcceptEnum = typeof GetMaterialMeanByIdAcceptEnum[keyof typeof GetMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const GetMaterialMeanEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetMaterialMeanEventsAcceptEnum = typeof GetMaterialMeanEventsAcceptEnum[keyof typeof GetMaterialMeanEventsAcceptEnum];
/**
 * @export
 */
export const GetMaterialMeanMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetMaterialMeanMetadataByIdAcceptEnum = typeof GetMaterialMeanMetadataByIdAcceptEnum[keyof typeof GetMaterialMeanMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfMaterialMeanByIdAcceptEnum = typeof ListChangeRequestsOfMaterialMeanByIdAcceptEnum[keyof typeof ListChangeRequestsOfMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const PatchMaterialMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchMaterialMeanByIdContentTypeEnum = typeof PatchMaterialMeanByIdContentTypeEnum[keyof typeof PatchMaterialMeanByIdContentTypeEnum];
/**
 * @export
 */
export const PatchMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchMaterialMeanByIdAcceptEnum = typeof PatchMaterialMeanByIdAcceptEnum[keyof typeof PatchMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const SearchMaterialMeanGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchMaterialMeanGetAcceptEnum = typeof SearchMaterialMeanGetAcceptEnum[keyof typeof SearchMaterialMeanGetAcceptEnum];
/**
 * @export
 */
export const SearchMaterialMeansPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchMaterialMeansPostContentTypeEnum = typeof SearchMaterialMeansPostContentTypeEnum[keyof typeof SearchMaterialMeansPostContentTypeEnum];
/**
 * @export
 */
export const SearchMaterialMeansPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchMaterialMeansPostAcceptEnum = typeof SearchMaterialMeansPostAcceptEnum[keyof typeof SearchMaterialMeansPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnMaterialMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnMaterialMeanByIdContentTypeEnum = typeof UpdateChangeRequestOnMaterialMeanByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnMaterialMeanByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnMaterialMeanByIdAcceptEnum = typeof UpdateChangeRequestOnMaterialMeanByIdAcceptEnum[keyof typeof UpdateChangeRequestOnMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const UpdateMaterialMeanByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateMaterialMeanByIdContentTypeEnum = typeof UpdateMaterialMeanByIdContentTypeEnum[keyof typeof UpdateMaterialMeanByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateMaterialMeanByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateMaterialMeanByIdAcceptEnum = typeof UpdateMaterialMeanByIdAcceptEnum[keyof typeof UpdateMaterialMeanByIdAcceptEnum];
/**
 * @export
 */
export const UpsertMaterialMeanACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertMaterialMeanACLAuthorizationByIdContentTypeEnum = typeof UpsertMaterialMeanACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertMaterialMeanACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertMaterialMeanACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertMaterialMeanACLAuthorizationByIdAcceptEnum = typeof UpsertMaterialMeanACLAuthorizationByIdAcceptEnum[keyof typeof UpsertMaterialMeanACLAuthorizationByIdAcceptEnum];
